






































































































































































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import { Datetime } from 'vue-datetime';
import { IPartnerUserDetail, ITagsGroup } from '@/interfaces';
import { dispatchGetPartnerDetail, dispatchGetTagsGroupsFields } from '@/store/main/actions';
import Multiselect from 'vue-multiselect';
import moment from 'moment';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
    MdIcon,
    Datetime,
    Multiselect,
  },
})
export default class CreatePartnerModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public lead: any;
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public groupsFilter: string;
  public formError = false;
  public telDropdownOpen = false;
  public leadDetail: IPartnerUserDetail | null = null;
  public employee: number | null = null;
  public avatar: any = null;
  public email = '';
  public firstName = '';
  public lastName = '';
  public country = '';
  public city = '';
  public phone = '';
  public dateBirth: any = '';
  public isPartner = false;
  public formattedPhone = '';
  public groups: number[] = [];
  public loadingState = {
    page: true,
    submit: false,
  };
  public tagsGroups: ITagsGroup[] = [];
  public tagsGroupsFields: any = {};
  public phoneError: any = {
    value: false,
    hint: '',
  };
  public showPhoneInput: boolean = false;

  public async mounted() {
    this.tagsGroups = await dispatchGetTagsGroupsFields(this.$store);
    if (this.lead) {
      const response = await dispatchGetPartnerDetail(this.$store, {id: this.lead.pk});
      if (response) {
        this.leadDetail = response;
        this.email = response.email;
        this.firstName = response.first_name;
        this.lastName = response.last_name;
        this.phone = response.phone ? `+${response.phone}` : '';
        this.dateBirth = response.date_birth ? response.date_birth : '';
        this.country = response.country_with_flag;
        this.city = response.city;
        this.isPartner = response.is_partner;
        this.groups = response.groups_ids;
      }
    } else {
      this.showPhoneInput = true;
    }

    let newTagsGroupsFields = {};
    for (let i in this.tagsGroups) {
      newTagsGroupsFields[this.tagsGroups[i].id] = this.leadDetail ? this.leadDetail.tags_ids : [];
    }
    this.tagsGroupsFields = newTagsGroupsFields;
    this.loadingState.page = false;
  }

  public validateForm() {
    if ((this.email && !/(.+)@(.+){1,}\.(.+){2,}/.test(this.email)) || this.email.includes('@@')) {
      this.formError = true;
      return false;
    } else if ( !this.phone || this.phoneError.value) {
      this.phoneError = {
        value: true,
        hint: this.$t('Write phone number'),
      };
    } else if (!this.firstName || !this.lastName || !this.country) {
      this.formError = true;
      return false;
    } else {
      this.phoneError = {
        value: false,
        hint: '',
      };
      this.formError = false;
      return true;
    }
  }

  public async validatePhone(payload) {
    this.formattedPhone = payload.formattedNumber ? payload.formattedNumber : '';
    if (payload.isValid) {
      const response = await api.validateUserPhone(
        {phone: payload.formattedNumber, user: this.lead ? this.lead.pk : null },
      );
      this.phoneError = {
        value: !response.data.valid,
        hint: !response.data.valid ? this.$t('Phone is already in use') : '',
      };
    } else if (payload.phoneNumber) {
      this.phoneError = {
        value: !payload.isValid,
        hint: !payload.isValid ? this.$t('Phone is incorrect') : '',
      };
    } else {
      this.phoneError = {
        value: false,
        hint: '',
      };
    }
  }

  public resetForm() {
    if (this.lead && this.leadDetail) {
      this.employee = null;
      this.email = this.leadDetail.email;
      this.firstName = this.leadDetail.first_name;
      this.lastName = this.leadDetail.last_name;
      this.phone = this.leadDetail.phone;
      this.dateBirth = this.leadDetail.date_birth ? this.leadDetail.date_birth : '';
      this.country = this.leadDetail.country_with_flag;
      this.city = this.leadDetail.city;
      this.isPartner = this.leadDetail.is_partner;
      this.groups = this.leadDetail.groups_ids;
    } else {
      this.employee = null;
      this.email = '';
      this.firstName = '';
      this.lastName = '';
      this.country = '';
      this.city = '';
      this.phone = '';
      this.formattedPhone = '';
      this.dateBirth = '';
      this.isPartner = false;
    }
    this.$emit('close-modal');
  }

  public generatePayload() {
    const formData = new FormData();
    if (this.lead) {
      formData.append('id', this.lead.pk);
    }
    // @ts-ignore
    formData.append('employee', this.employee ? this.employee : '');
    formData.append('email', this.email);
    if (this.avatar) {
      formData.append('avatar', this.avatar);
    }
    formData.append('first_name', this.firstName);
    formData.append('last_name', this.lastName);
    formData.append('country_with_flag', this.country);
    formData.append('city', this.city);
    console.log(this.formattedPhone);
    if (!this.formattedPhone && this.phone) {
      formData.append('phone', this.phone);
    } else {
      formData.append('phone', this.formattedPhone);
    }
    console.log(this.dateBirth);
    formData.append('date_birth', this.dateBirth);
    // @ts-ignore
    formData.append('is_partner', this.isPartner);
    
    for (const [key, value] of Object.entries(this.tagsGroupsFields)) {
      // @ts-ignore
      formData.append(`tags_group_${key}`, JSON.stringify(value));
    }

    return formData;
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      this.loadingState.submit = true;
      try {
        const payload = await this.generatePayload();
        const response = await api.createPartnerManually(
          this.$store.getters.token, payload,
        );
        // @ts-ignore
        this.showToast(this, this.$t('Contact saved'));
        this.$emit('partner-created');
        this.resetForm();
      } catch (error) {
        // @ts-ignore
        if (error.response && error.response.data) {
          let errorMsg = '';
          // @ts-ignore
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
      this.loadingState.submit = false;
    }
  }

  public async uploadAvatar(e) {
    if (e.target.files[0] !== undefined) {
      this.avatar = e.target.files[0];
    }
  }

  get getAvatarUrl() {
    if (this.avatar) {
      return URL.createObjectURL(this.avatar);
    } else if (this.leadDetail && this.leadDetail.avatar) {
      return this.leadDetail.avatar;
    } else {
      return '';
    }
  }
  
  public handleChangeConsultant(value) {
    this.employee = value;
  }

  public handleChangeField(field, value) {
    console.log(field, value);
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.tagsGroupsFields[field.id] = newList;
    console.log(this.tagsGroupsFields[field.id]);
  }

  public fieldValue(field) {
    const newList: any = [];
    for (const [key, value] of Object.entries(field.tags)) {
      // @ts-ignore
      if (this.tagsGroupsFields[field.id].includes(value.id)) {
        newList.push(value);
      }
    }
    return newList;
  }

  public handleChangeGroup(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.groups = newList;
  }

  public handleEditPhone() {
    this.showPhoneInput = true;
    this.phone = '';
    this.formattedPhone = '';
  }

  public checkGroups(groups) {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

  public handleChangeCountry(value) {
    this.country = value;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

}
